// Lightweight client-side meta/OG updater (CRA has no SSR).
export function setMeta({ title, description, image, url }) {
  if (title) document.title = title;

  const upsert = (attr, key, content) => {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  upsert("name", "description", description);
  upsert("property", "og:title", title);
  upsert("property", "og:description", description);
  upsert("property", "og:type", "website");
  if (image) upsert("property", "og:image", image);
  if (url) upsert("property", "og:url", url);
  upsert("name", "twitter:card", image ? "summary_large_image" : "summary");
  upsert("name", "twitter:title", title);
  upsert("name", "twitter:description", description);
  if (image) upsert("name", "twitter:image", image);
}

export const SITE_URL = process.env.REACT_APP_SITE_URL || "https://stayflowapp.in";
